module.exports = {
	"id": "GI",
	"name": "Gibraltar",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.016599,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.022132,
			"32": 0.038731,
			"33": 0.005533,
			"34": 0.016599,
			"35": 0.022132,
			"36": 0.022132,
			"37": 0.011066,
			"38": 0.016599,
			"39": 0.841016,
			"40": 0.005533,
			"41": 0.005533,
			"42": 0.027665,
			"43": 0.071929,
			"44": 0.027665,
			"45": 0.011066,
			"46": 0.071929,
			"47": 0.05533,
			"48": 1.172996,
			"49": 1.444113,
			"50": 0.641828,
			"51": 2.406855,
			"52": 0.188122,
			"53": 18.458088,
			"54": 5.173355,
			"55": 0.044264,
			"56": 0.033198,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.016599,
			"31": 0.016599,
			"32": 0.011066,
			"33": 0.027665,
			"34": 0.016599,
			"35": 0.016599,
			"36": 0.033198,
			"37": 0.049797,
			"38": 1.316854,
			"39": 0.066396,
			"40": 0.066396,
			"41": 0.05533,
			"42": 0.066396,
			"43": 0.603097,
			"44": 0.044264,
			"45": 0.641828,
			"46": 0.265584,
			"47": 1.067869,
			"48": 0.309848,
			"49": 3.341932,
			"50": null,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.016599
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.005533,
			"38": 0.11066,
			"39": null,
			"40": 0.215787,
			"41": 0.022132,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.105127,
			"6": null,
			"7": 0.011066,
			"8": 0.392843,
			"9": 0.204721,
			"10": 1.587971,
			"3.1": null,
			"3.2": null,
			"5.1": 0.038731,
			"6.1": 0.127259,
			"7.1": 0.022132,
			"9.1": 1.742895
		},
		"ios_saf": {
			"8": 0,
			"10": 16.800352005,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.45275004642,
			"8.1-8.4": 0.836436526436,
			"9.0-9.2": 0.399033939217,
			"9.3": 6.08782548293
		},
		"android": {
			"3": 0,
			"4": 0.0228608423773,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00285760529716,
			"4.1": 0.0824623242894,
			"4.2-4.3": 0.206155810724,
			"4.4": 0.472729562016,
			"4.4.3-4.4.4": 0.476811855297
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.132792,
			"9": 0.177056,
			"10": 0.392843,
			"11": 5.427873,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00492779477783,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000136883188273
		},
		"edge": {
			"12": 0.044264,
			"13": 0.464772,
			"14": 1.731829
		},
		"ie_mob": {
			"10": 0.0590015211268,
			"11": 0.240220478873
		},
		"bb": {
			"7": 0.008932,
			"10": null
		},
		"samsung": {
			"0": 3.197656
		},
		"and_uc": {
			"0": 0.125048
		},
		"op_mini": {
			"0": 0.0663913220339
		},
		"and_chr": {
			"0": 15.366549
		},
		"and_ff": {
			"0": 0.017864
		}
	},
	"total": 96.787812
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GI.json
 ** module id = 531
 ** module chunks = 0
 **/